import * as React from "react"
import { Keys } from "@digits-shared/components/UI/Elements/Keys"

export function useOnEnter(onEnter?: (e: KeyboardEvent) => void) {
  return React.useCallback(
    (e: React.KeyboardEvent<HTMLElement>) => {
      const { key } = e
      if (key === Keys.Enter && onEnter) {
        e.preventDefault()
        e.stopPropagation()
        onEnter(e.nativeEvent)
      }
    },
    [onEnter]
  )
}
